import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            探索设计主题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
            从配色理论到实战案例，系统化学习女性网站色彩设计
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100/70 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium">
                {cat.articleCount} 篇文章
                <i className="ri-arrow-right-line text-xs transition-transform duration-200 group-hover:translate-x-0.5"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}